import React from "react";
import Layout from "../layout/Layout";
import { Card, Col, Flex, Row, Typography } from "antd";
const { Title, Text } = Typography;

const QCMenu = ({ history }) => {
	const showDashboard = () => {
		history.push("/qc/dashboard");
	};

	const showQCJobsReport = () => {
		history.push("/qc/jobreport/menu");
	};

	const showQCMixDesigns = () => {
		history.push("/qc/mixdesigns/menu");
	};

	const CustomDashboard = () => {
		return (
			<div>
				<Row gutter={16}>
					{(localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "ss@57concrete.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<Col span={8}>
							<Card
								bordered
								style={{ backgroundColor: "#16207cff", cursor: "pointer" }}
								onClick={showDashboard}
							>
								<Flex align="center" justify="center" vertical>
									<Title level={2} style={{ color: "white" }}>
										Dashboard
									</Title>
									<Text style={{ color: "white" }}>QA/QC</Text>
								</Flex>
							</Card>
						</Col>
					)}
					{(localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "ss@57concrete.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<Col span={8}>
							<Card
								bordered
								style={{ backgroundColor: "#3533b6ff", cursor: "pointer" }}
								onClick={showQCJobsReport}
							>
								<Flex align="center" justify="center" vertical>
									<Title level={2} style={{ color: "white" }}>
										Job Report
									</Title>
									<Text style={{ color: "white" }}>QA/QC Jobs</Text>
								</Flex>
							</Card>
						</Col>
					)}
					{(localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "ss@57concrete.com" ||
						localStorage.getItem("email") === "rl@57concrete.com" ||
						localStorage.getItem("email") === "jh@57concrete.com" ||
						localStorage.getItem("email") === "dmad@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<Col span={8}>
							<Card
								bordered
								style={{
									backgroundColor: "rgb(51, 110, 182)",
									cursor: "pointer",
								}}
								onClick={showQCMixDesigns}
							>
								<Flex align="center" justify="center" vertical>
									<Title level={2} style={{ color: "white" }}>
										Mix Designs
									</Title>
									<Text style={{ color: "white" }}>
										Products & Raw Materials
									</Text>
								</Flex>
							</Card>
						</Col>
					)}
				</Row>
			</div>
		);
	};

	return (
		<Layout title="QA/QC" description="Menu">
			<CustomDashboard />
		</Layout>
	);
};

export default QCMenu;
